// ============================================================
// Clínica — "banco" in-memory mutável (Fase 2)
// ------------------------------------------------------------
// Clona o seed (src/data/clinica) para uma estrutura mutável. As
// transições de estado (confirmar consulta, aprovar repasse, criar
// médico…) mutam ESTE objeto, então persistem durante a sessão sem
// alterar o seed original. Reset ao recarregar a página.
// Quando a API real existir, os services deixam de tocar aqui.
// ============================================================
import seed from "@/data/clinica";

const clone = obj => JSON.parse(JSON.stringify(obj));

export const db = {
  clinics: clone(seed.clinics),
  units: clone(seed.units),
  operators: clone(seed.operators),
  specialties: clone(seed.specialties),
  doctors: clone(seed.doctors),
  patients: clone(seed.patients),
  timelineEvents: clone(seed.timelineEvents),
  notes: clone(seed.notes),
  appointments: clone(seed.appointments),
  confirmationsQueue: clone(seed.confirmationsQueue),
  reschedulesQueue: clone(seed.reschedulesQueue),
  opportunityGroups: clone(seed.opportunityGroups),
  campaigns: clone(seed.campaigns),
  campaignFunnel: clone(seed.campaignFunnel),
  financeSummary: clone(seed.financeSummary),
  financeEvolution: clone(seed.financeEvolution),
  receivables: clone(seed.receivables),
  transfers: clone(seed.transfers),
  statementEntries: clone(seed.statementEntries),
  financeBalanceCents: seed.financeBalanceCents,
  resources: clone(seed.resources),
  permissions: clone(seed.permissions),
  schedules: clone(seed.schedules),
  dashboardKpis: clone(seed.dashboardKpis)
};

// gerador de ids simples para novas entidades criadas em sessão
let _seq = 9000;
export const nextId = () => ++_seq;

export default db;
